module.exports = __webpack_public_path__ + "static/media/share_youtube.e60d0726.svg";